export default __webpack_public_path__ + "static/media/welcome.36b71d6d.svg";